// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3zSeE","header":"styles_header__MFK15","list":"styles_list__nMe0A"};